import { render, staticRenderFns } from "./priceDetails.vue?vue&type=template&id=660aa11c&scoped=true"
import script from "./priceDetails.vue?vue&type=script&lang=js"
export * from "./priceDetails.vue?vue&type=script&lang=js"
import style0 from "./priceDetails.vue?vue&type=style&index=0&id=660aa11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660aa11c",
  null
  
)

export default component.exports